import SoftTypography from 'components/SoftTypography'
import styled from 'styled-components'
import { useEffect, useState } from 'react'
import { usePlaidLink } from 'react-plaid-link'
import { useApi } from 'hooks/useApi'
import { useIntake } from 'hooks/useIntakeContext'
import { PlaidLogo } from 'components/PlaidLogo'
import { mapPlaidToParcoModel } from '../utils/mapPlaidToParcoModel'
import RefreshIcon from '@mui/icons-material/Refresh'

const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-width: 350px;
  width: 100%;
  margin: 0 auto;
  border-radius: 10px;
`

const StyledSpan = styled.span`
  width: auto;
  padding: 0 15px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    transition: 0.2s transform ease-in-out;
    transform: scale(1.03);
    box-shadow: 1px 10px 5px #efefef;
    cursor: pointer;
  }
`

export const ImportFromPlaid = ({ handleUpdateAccounts, height = '15px' }) => {
  const [linkToken, setLinkToken] = useState()
  const { intakeState, updateIntakeStateAtKey } = useIntake()
  const { apiRequest } = useApi()

  const onSuccess = async (public_token, metadata) => {
    // If the access_token is needed, send public_token to server
    const {
      institution: { institution_id },
    } = metadata
    await apiRequest('/api/set_access_token', {
      method: 'POST',
      body: JSON.stringify({ public_token: public_token, institution_id }),
    })
    setTimeout(async () => {
      await getAssets()
    }, 300)
  }

  const generateToken = async () => {
    const createLinkToken = async (forceRefresh = false) => {
      // Link tokens for 'payment_initiation' use a different creation flow in your backend.
      const path = '/api/create_link_token'
      const response = await apiRequest(
        `${path}${forceRefresh ? `?forceRefresh=${forceRefresh}` : ''}`,
        {
          method: 'POST',
        }
      )
      if (!response.ok) {
        console.log('response was NOT ok')
        return
      }
      return response.json()
    }
    const data = await createLinkToken()
    if (data.link_token) {
      setLinkToken(data.link_token)
    } else if (data.hasAccessToken) {
      const assetResponse = await getAssets()

      //   // this isn't the right thing to do - we need to figure out a better
      //   // way to update link tokens to re-grant access because the account's ids are unique
      //   // ONLY scoped to the access token they generate. If you force regeneration, then
      //   // it will duplicate accounts
      //   if (assetResponse) {
      //     if (assetResponse.errorCode) {
      //       console.error(
      //         'Could not get assets - retrying link token creation',
      //         assetResponse.errorCode
      //       )
      //       const { link_token } = await createLinkToken(true)
      //       setLinkToken(link_token)
      //     }
      //   }
    }
  }

  const config = {
    token: linkToken,
    onSuccess,
  }
  const { open, ready } = usePlaidLink(config)

  const getAssets = async () => {
    const response = await apiRequest('/api/plaid/assets')
    const data = await response.json()
    if (data.errorCode) {
      console.error('error fetching assets', data.errorCode)
      return data
    }
    handleUpdateAccounts && handleUpdateAccounts()
  }

  useEffect(() => {
    ready && open()
  }, [ready, open])

  return (
    <>
      <StyledDiv onClick={generateToken}>
        <StyledSpan>
          <SoftTypography textAlign="center" color="dark" variant="body2">
            Add new accounts from
          </SoftTypography>
          &nbsp;
          <PlaidLogo />
        </StyledSpan>
      </StyledDiv>
      <StyledDiv onClick={getAssets}>
        <StyledSpan>
          <SoftTypography textAlign="center" color="dark" variant="body2">
            Refresh accounts
          </SoftTypography>
          &nbsp;
          <RefreshIcon />
        </StyledSpan>
      </StyledDiv>
    </>
  )
}
